export enum DeactivateReason{
    InventoryTemporarilyUnavailable = 'Inventory Temporarily Unavailable',
    WaitingOnUpdatedPricing = 'Waiting on Updated Pricing',
    SpecChangeDataConfirmation = 'Spec Change/Data Confirmation',
    ePalletAdminTest = 'Epallet Admin Test'
}